import config from '../../constants/endpoints.js'
import getHeaders from '../helpers/headers'
import axios from 'axios'

// TO CONNECT WITH BACK

/**
 * Get bookings list or specific booking details.
 *
 * @param {String} bookingId Used to get the specific booking details
 */
export const getBookings = (params) =>
  axios({
    data: params,
    url: config.endpoints.bookings.post,
    method: 'post',
    headers: getHeaders(true)
  })

/**
 * Get bookings list or specific booking details.
 *
 * @param {String} bookingId Used to get the specific booking details
 */
export const getDetailedBooking = (id) =>
  axios({
    url: config.endpoints.bookings.getDetails.replace(':bookingId', id),
    method: 'get',
    headers: getHeaders(true),
  })

/**
 * Get bookings list or specific booking details with updateFromApi.
 *
 * @param {String} bookingId Used to get the specific booking details
 * @param {String} updateFromApi Used to get updated booking from api
 */
export const getDetailedBookingFromApi = (id, updateFromApi) =>
  axios({
    url: config.endpoints.bookings.getDetailsFromApi.replace(':bookingId', id).replace('paramUpdateFromApi', updateFromApi),
    method: 'get',
    headers: getHeaders(true),
  })

/**
 * Get insurance details.
 *
 * @param {String} bookingId Used to get the specific booking details
 */
export const getInsurance = (id) =>
  axios({
    url: config.endpoints.bookings.getInsurance.replace(':bookingId', id),
    method: 'get',
    headers: getHeaders(true),
  })

/**
 * Cancel a specific booking.
 *
 * @param {String} bookingId Booking Id
 */
export const cancelBooking = (bookingId, method = 'get') =>
  axios({
    method,
    url: config.endpoints.bookings.cancel.replace(':bookingId', bookingId),
    headers: getHeaders(true),
  })

/**
 * Action that requests to void a specific booking.
 *
 * @param {String} bookingId Booking Id
 */
export const voidBooking = (bookingId, method = 'get') =>
  axios({
    method,
    url: config.endpoints.bookings.void.replace(':bookingId', bookingId),
    headers: getHeaders(true),
  })

/**
 * Emits the ticket of a specific booking.
 *
 * @param {String} bookingId Booking Id
 */
export const emitBooking = (bookingId, method = 'get') =>
  axios({
    method,
    url: config.endpoints.bookings.emit.replace(':bookingId', bookingId),
    headers: getHeaders(true),
  })

/**
 * Modify a booking.
 *
 * @param {Object} data Modified data of the booking
 */
export const modifyBooking = (data, method = 'put') =>
  axios({
    data,
    method,
    url: config.endpoints.bookings.modify.replace(':bookingId', data.bookingId),
    headers: getHeaders(true),
  })

/**
 *  Download CSV with filters
 */
export const getCSVInfo = (params) =>
  axios({
    url: config.endpoints.bookings.exportCsv,
    method: 'get',
    responseType: 'blob',
    headers: getHeaders(true),
    params,
  })

/**
 * Get bookings list or specific user.
 *
 * @param {String} userId Used to get the specific user details
 */
export const getBookingByUser = (id) =>
  axios({
    url: config.endpoints.bookings.getBookings.replace(':userId', id),
    method: 'get',
    headers: getHeaders(true),
  })

/**
 * Get bookings list filter.
 *
 * @param {String} bookingId Used to get the specific booking details
 */
export const getBookingsFilters= () =>
  axios({
    url: config.endpoints.bookings.getFilters,
    method: 'get',
    headers: getHeaders(true),
  })
